import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Small } from 'foundations-components/transitional/components/Small';
import { Flex } from 'foundations-components/components/Flex';
import formatShortDate from 'I18n/utils/formatShortDate';
import { useInboxBusinessHoursReturnTime, useInboxIsOutsideBusinessHours } from 'conversations-inbox-lib/agent-status/public';
import { useSelector } from 'react-redux';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OutsideBusinessHours = () => {
  const inboxId = useSelector(getCurrentInboxId);
  const isOutsideBusinessHours = useInboxIsOutsideBusinessHours({
    inboxId
  });
  const returnTime = useInboxBusinessHoursReturnTime({
    inboxId
  });
  if (!isOutsideBusinessHours || !returnTime) return null;
  const returnTimeMoment = I18n.moment(returnTime);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    paddingInline: "200",
    paddingBlockEnd: "500",
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.agentStatus.outsideBusinessHours.label"
      })
    }), /*#__PURE__*/_jsx(HelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.agentStatus.outsideBusinessHours.tooltip",
        options: {
          dayOfWeek: returnTimeMoment.format('ddd'),
          day: formatShortDate(returnTime, 'portalTz'),
          time: returnTimeMoment.format('LT')
        }
      }),
      marginInlineStart: "100"
    })]
  });
};
OutsideBusinessHours.displayName = 'OutsideBusinessHours';
export default OutsideBusinessHours;